import { defineStore } from 'pinia';
import { ref } from 'vue';

export type ClientPublishDialogCallback = (status: string) => void;
interface ConfirmProps {
  cancelButtonText?: string | null;
  confirmButtonText?: string;
  hideCloseIcon?: boolean;
  maxWidth?: string;
  buttonFullWidth?: boolean;
  zIndex?: number;
  size?: 's' | 'm' | 'l';
}

export interface ClientPublishDialogOptions extends ConfirmProps {
  callback?: ClientPublishDialogCallback;
}

export interface ClientPublishDialogData extends ClientPublishDialogOptions {
  resolve: (value: boolean) => void;
}

export const useClientPublishDialogStore = defineStore('clientPublishDialog', () => {
  const isOpen = ref<boolean>(false);
  const props = ref<ClientPublishDialogData | null>(null);

  const openClientPublishDialog = (dialogData: ClientPublishDialogData): void => {
    props.value = dialogData;
    isOpen.value = true;
  };

  const onClose = (confirmed: boolean): void => {
    if (props.value) {
      props.value.resolve(confirmed);
      // Adjust the interval for the animation
      setTimeout(() => {
        isOpen.value = false;
        props.value = null;
      }, 0);
    }
    isOpen.value = false;
  };

  return { isOpen, props, openClientPublishDialog, onClose };
});

export const openClientPublishDialog = (options?: ClientPublishDialogOptions): Promise<boolean> => {
  return new Promise((resolve) => {
    useClientPublishDialogStore().openClientPublishDialog({ ...options, resolve });
  });
};
